import React, { useState } from 'react';

import CrmLayout from "../../components/CrmLayout";

import { Empty, message, Pagination, Skeleton } from 'antd';

import {useQuery} from '@apollo/client';
import CrmCenteredTitle from "../../components/CrmCenteredTitle";

import { QUERY_PROJECTS } from '../../graphql/project';
import { toProject } from '../../routes';
import { Link, useNavigate } from 'react-router-dom';
import _ from 'lodash';

import cls from './Project.module.scss'
import ImageUrl from '../../helpers/ImageUrl';
import cn from 'classnames';
import { isDark } from '../../helpers/color';

export default function Projects() {

    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    const query = useQuery(QUERY_PROJECTS, {
        variables: {
            pagination: {
                pageSize: 20,
                page: page,
            }
        },
        onError: (error) => {
            message.error(error.message);
        }
    });

    const onAdd = () => {
        navigate(toProject('new'))
    }

    return (

        <CrmLayout>

            <CrmCenteredTitle title={'Проекты'} addAction={onAdd}/>

            {query.loading && <Skeleton active/>}

            {query.data?.projects?.data?.length === 0 && (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}

            <div className={cls.grid}>
            {_.map(query.data?.projects?.data, (project) => (
                <Link key={project.id} to={toProject(project.id)} className={cls.item} style={{
                    backgroundColor: project.attributes?.color,
                    backgroundImage: `url(${ImageUrl(project.attributes?.cover?.data?.attributes?.url)}`,
                }}>
                    <div className={cn(cls.name, isDark(project.attributes.color || '#F0F0F0') && cls.white)}>
                        {project.attributes.name}
                    </div>
                    <div className={cls.logo}>
                        {project.attributes.logo?.data && <img src={ImageUrl(project.attributes.logo?.data?.attributes?.url)} alt={project.attributes.name}/>}
                    </div>
                </Link>
            ))}
            </div>

            {query.data &&
            <Pagination
                className={'crm-task-pagination'}
                defaultCurrent={query.data?.projects?.meta?.pagination?.page}
                current={query.data?.projects?.meta?.pagination?.page}
                total={query.data?.projects?.meta?.pagination?.total}
                pageSize={query.data?.projects?.meta?.pagination?.pageSize}
                onChange={(page) => {setPage(page)}}
            />
            }

            <div className={cls.list}>
            </div>

        </CrmLayout>
    );
}



